export default __webpack_public_path__ + "static/media/zarya-intro.f178952d.mp3";